


// document.addEventListener('DOMContentLoaded', function () {
//   // Cart click proxy
//   const mobileCart = document.querySelector('.cstm-mobile-header .header__icon--cart');
//   const mainCart = document.querySelector('.header__icon.header__icon--cart');

//   if (mobileCart && mainCart) {
//     mobileCart.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       mainCart.click();
//     });
//   }

//   // Notification click proxy
//   const mobileNotify = document.querySelector('.cstm-mobile-header .header__icon.notify');
//   const mainNotify = document.querySelector('.header__icon.notify');

//   if (mobileNotify && mainNotify) {
//     mobileNotify.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       mainNotify.click();
//     });
//   }
// });


// document.addEventListener('DOMContentLoaded', function () {
//     const hamburger = document.querySelector('.cstm-hamburger');
//     const mobileHeader = document.querySelector('.cstm-mobile-header');
//     const menuDrawer = document.querySelector('.cstm-menu-drawer');
//     const menuOverlay = document.querySelector('.cstm-menu-overlay');
//     const cartIcon = document.getElementById('cart-icon-bubble');
//     const searchModal = document.querySelector('details-modal .header__search details');
//     const accountIcon = document.querySelector('.header__icon--account');
//     const notifyIcon = document.querySelector('.header__icon.notify');

//     // सभी interactive icons/elements का collection
//     const allInteractiveElements = [
//         { element: hamburger, activeClass: 'active', target: mobileHeader, additionalAction: null },
//         { element: cartIcon, activeClass: 'active', target: null, additionalAction: null },
//         { element: searchModal, activeClass: 'open', target: searchModal, additionalAction: null },
//         { element: accountIcon, activeClass: 'active', target: null, additionalAction: null },
//         { element: notifyIcon, activeClass: 'active', target: null, additionalAction: null }
//     ];

//     // किसी एक element को activate करने के लिए function
//     function activateElement(clickedElement) {
//         // पहले सभी elements से active classes हटाएं
//         deactivateAllElements();

//         // जिस element पर click किया है, उसे activate करें
//         const foundElement = allInteractiveElements.find(item => {
//             return item.element === clickedElement || 
//                    (clickedElement.closest && clickedElement.closest(item.element.selector || ''));
//         });

//         if (foundElement) {
//             if (foundElement.target) {
//                 foundElement.target.classList.add(foundElement.activeClass);
//             }
//             if (foundElement.element === hamburger) {
//                 // Hamburger के लिए विशेष handling
//                 menuDrawer.classList.add('cstm-open');
//                 menuOverlay.classList.add('cstm-active');
//                 document.body.style.overflow = 'hidden';
//             }
//             if (foundElement.additionalAction) {
//                 foundElement.additionalAction();
//             }
//         }
//     }

//     // सभी elements को deactivate करने के लिए function
//     function deactivateAllElements() {
//         // Hamburger/menu को close करें
//         if (mobileHeader) mobileHeader.classList.remove('active');
//         if (menuDrawer) menuDrawer.classList.remove('cstm-open');
//         if (menuOverlay) menuOverlay.classList.remove('cstm-active');
        
//         // Search modal को close करें
//         if (searchModal && searchModal.hasAttribute('open')) {
//             searchModal.removeAttribute('open');
//         }
        
//         // अन्य icons से active class हटाएं
//         [cartIcon, accountIcon, notifyIcon].forEach(icon => {
//             if (icon) icon.classList.remove('active');
//         });
        
//         // Body overflow reset करें
//         document.body.style.overflow = '';
//     }

//     // Hamburger के लिए event listener
//     if (hamburger) {
//         hamburger.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (mobileHeader.classList.contains('active')) {
//                 // अगर पहले से active है तो deactivate करें
//                 deactivateAllElements();
//             } else {
//                 // नहीं तो activate करें
//                 activateElement(hamburger);
//             }
//         });
//     }

//     // Cart icon के लिए event listener
//     if (cartIcon) {
//         cartIcon.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (this.classList.contains('active')) {
//                 this.classList.remove('active');
//             } else {
//                 activateElement(this);
//             }
//         });
//     }

//     // Search modal के लिए event listener
//     if (searchModal) {
//         const searchSummary = searchModal.querySelector('summary');
//         if (searchSummary) {
//             searchSummary.addEventListener('click', function (e) {
//                 e.stopPropagation();
//                 if (searchModal.hasAttribute('open')) {
//                     searchModal.removeAttribute('open');
//                     searchModal.classList.remove('open');
//                 } else {
//                     activateElement(searchModal);
//                     searchModal.setAttribute('open', '');
//                 }
//             });
//         }
//     }

//     // Account icon के लिए event listener
//     if (accountIcon) {
//         accountIcon.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (this.classList.contains('active')) {
//                 this.classList.remove('active');
//             } else {
//                 activateElement(this);
//             }
//         });
//     }

//     // Notify icon के लिए event listener
//     if (notifyIcon) {
//         notifyIcon.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (this.classList.contains('active')) {
//                 this.classList.remove('active');
//             } else {
//                 activateElement(this);
//             }
//         });
//     }

//     // Overlay पर click करने पर सब कुछ close करें
//     if (menuOverlay) {
//         menuOverlay.addEventListener('click', function (e) {
//             e.stopPropagation();
//             deactivateAllElements();
//         });
//     }

//     // Document पर click करने पर check करें कि क्या click किसी active element के बाहर हुआ है
//     document.addEventListener('click', function (e) {
//         const isClickInsideMenu = menuDrawer && menuDrawer.contains(e.target);
//         const isClickOnHamburger = hamburger && hamburger.contains(e.target);
//         const isClickOnCart = cartIcon && cartIcon.contains(e.target);
//         const isClickOnSearch = searchModal && searchModal.contains(e.target);
//         const isClickOnAccount = accountIcon && accountIcon.contains(e.target);
//         const isClickOnNotify = notifyIcon && notifyIcon.contains(e.target);
        
//         // अगर click किसी भी interactive element के अंदर नहीं हुआ है
//         if (!isClickOnHamburger && !isClickOnCart && !isClickOnSearch && 
//             !isClickOnAccount && !isClickOnNotify && !isClickInsideMenu) {
//             deactivateAllElements();
//         }
//     });

//     // Body overflow का management
//     const updateBodyOverflow = () => {
//         if (mobileHeader && mobileHeader.classList.contains('active')) {
//             document.body.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//         }
//     };

//     // Initial state (page load)
//     updateBodyOverflow();

//     // Observe class changes
//     if (mobileHeader) {
//         const observer = new MutationObserver(updateBodyOverflow);
//         observer.observe(mobileHeader, {
//             attributes: true,
//             attributeFilter: ['class']
//         });
//     }
// });


// document.addEventListener('DOMContentLoaded', function () {

//   // CART PROXY (unchanged)
//   const mobileCart = document.querySelector('.cstm-mobile-header .header__icon--cart');
//   const mainCart = document.querySelector('.header__icon.header__icon--cart');

//   if (mobileCart && mainCart) {
//     mobileCart.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       mainCart.click();
//     });
//   }

//   // NOTIFICATION LOGIC
//   const mobileNotify = document.querySelector('.cstm-mobile-header .header__icon.notify');
//   const mainNotify   = document.querySelector('.header__icon.notify');
//   const closeNotify  = document.querySelector('#close-notification');

//   if (mobileNotify && mainNotify) {
//     mobileNotify.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       // toggle body class
//       document.body.classList.toggle('active');

//       // trigger main notify click ONLY when opening
//       if (document.body.classList.contains('active')) {
//         mainNotify.click();
//       }
//     });
//   }

//   // CLOSE BUTTON
//   if (closeNotify) {
//     closeNotify.addEventListener('click', function () {
//       document.body.classList.remove('active');
//     });
//   }

// });











// ya new wala ha








// document.addEventListener('DOMContentLoaded', function () {

//     // ───────────────────────────────────────────────
//     //  Elements
//     // ───────────────────────────────────────────────
//     const hamburger       = document.querySelector('.cstm-hamburger');
//     const mobileHeader    = document.querySelector('.cstm-mobile-header');
//     const menuDrawer      = document.querySelector('.cstm-menu-drawer');
//     const menuOverlay     = document.querySelector('.cstm-menu-overlay');
//     const levelsContainer = document.querySelector('.cstm-menu-levels');
//     const level1          = document.querySelector('.cstm-menu-level[data-level="1"]');

//     let history = [];           // keeps track of navigation stack

//     // ───────────────────────────────────────────────
//     //  Close everything
//     // ───────────────────────────────────────────────
//     function closeAll() {
//         mobileHeader?.classList.remove('active');
//         menuDrawer?.classList.remove('cstm-open');
//         menuOverlay?.classList.remove('cstm-active');
//         document.body.style.overflow = '';

//         // Reset levels
//         document.querySelectorAll('.cstm-menu-level').forEach(el => {
//             el.classList.remove('cstm-active', 'cstm-prev');
//         });
//         if (level1) level1.classList.add('cstm-active');

//         history = [];
//     }

//     // ───────────────────────────────────────────────
//     //  Go to next level
//     // ───────────────────────────────────────────────
//     function goToLevel(title, childrenContainer, isBack = false) {
//         if (!childrenContainer) return;

//         // Current active level
//         const current = document.querySelector('.cstm-menu-level.cstm-active');
//         if (!current) return;

//         // Create new level if needed
//         let newLevel = document.querySelector(`.cstm-menu-level[data-title="${CSS.escape(title)}"]`);
//         if (!newLevel) {
//             newLevel = document.createElement('div');
//             newLevel.className = 'cstm-menu-level';
//             newLevel.dataset.title = title;
//             newLevel.innerHTML = `
//                 <div class="custom-back-header">
//                     <button class="cstm-back-btn">
//                         <svg viewBox="0 0 292 492"><path d="M282.666 226.796L63.338 7.86402C58.274 2.79202 51.322 0.00800542 44.114 5.73162e-06C36.902 6.04687e-06 30.046 2.79202 24.986 7.86402L8.75798 23.98C3.68998 29.052 0.897983 35.8 0.897983 43.012C0.897983 50.22 3.68998 56.976 8.75798 62.048L192.606 245.888L8.554 429.94C3.486 435.004 0.697996 441.76 0.697996 448.968C0.697996 456.176 3.486 462.936 8.554 468.004L24.682 484.124C35.17 494.62 52.254 494.62 62.742 484.124L282.666 264.988C287.73 259.924 291.298 253.176 291.298 245.904L291.298 245.82C291.298 238.608 287.726 231.86 282.666 226.796Z" fill="black"></path></svg>
//                     </button>
//                     <div class="cstm-menu-title">${title}</div>
//                     <div style="width:40px"></div>
//                 </div>
//                 <ul class="cstm-menu-list"></ul>
//             `;

//             // Copy children items
//             const list = newLevel.querySelector('.cstm-menu-list');
//             childrenContainer.querySelectorAll('.cstm-child, .cstm-grand').forEach(item => {
//                 const li = document.createElement('li');
//                 li.className = 'cstm-menu-item';
//                 li.dataset.hasChildren = item.dataset.hasChildren;

//                 const a = document.createElement('a');
//                 a.href = item.dataset.url || '#';
//                 a.className = 'cstm-menu-link';

//                 // Image
//                 if (item.dataset.image && item.dataset.image !== 'null' && item.dataset.image !== '') {
//                     const img = document.createElement('img');
//                     img.src = item.dataset.image;
//                     img.className = 'cstm-item-image';
//                     a.appendChild(img);
//                 }

//                 // Text block
//                 const textDiv = document.createElement('div');
//                 textDiv.className = 'cstm-item-text';

//                 const innerDiv = document.createElement('div');
//                 const titleDiv = document.createElement('div');
//                 titleDiv.className = 'cstm-item-title';
//                 titleDiv.textContent = item.dataset.title;
//                 innerDiv.appendChild(titleDiv);

//                 if (item.dataset.description && item.dataset.description !== '') {
//                     const desc = document.createElement('div');
//                     desc.className = 'cstm-item-description';
//                     desc.textContent = item.dataset.description;
//                     innerDiv.appendChild(desc);
//                 }

//                 textDiv.appendChild(innerDiv);

//                 if (item.dataset.tag && item.dataset.tag !== '') {
//                     const tagSpan = document.createElement('span');
//                     tagSpan.className = 'cstm-item-tag';
//                     tagSpan.textContent = item.dataset.tag;
//                     textDiv.appendChild(tagSpan);
//                 }

//                 a.appendChild(textDiv);

//                 // Arrow if has children
//                 if (item.dataset.hasChildren === 'true') {
//                     const arrow = document.createElement('span');
//                     arrow.className = 'cstm-arrow';
//                     arrow.innerHTML = `<svg viewBox="0 0 292 492"><path d="M282.666 226.796L63.338 7.86402...Z" fill="black"/></svg>`;
//                     a.appendChild(arrow);
//                 }

//                 li.appendChild(a);

//                 // Store next children for later
//                 if (item.dataset.hasChildren === 'true') {
//                     const nextData = item.querySelector('.cstm-level3-data') || item.nextElementSibling;
//                     if (nextData) {
//                         li.dataset.childrenContainer = nextData.outerHTML;
//                     }
//                 }

//                 list.appendChild(li);
//             });

//             levelsContainer.appendChild(newLevel);
//         }

//         // Animation direction
//         if (isBack) {
//             current.classList.add('cstm-prev');
//             newLevel.classList.add('cstm-active');
//         } else {
//             current.classList.remove('cstm-active');
//             current.classList.add('cstm-prev');
//             newLevel.classList.add('cstm-active');
//         }

//         // Remember where we came from
//         if (!isBack) {
//             history.push(current);
//         } else {
//             history.pop();
//         }
//     }

//     // ───────────────────────────────────────────────
//     //  Event delegation – click on items / arrows / back
//     // ───────────────────────────────────────────────
//     menuDrawer.addEventListener('click', function (e) {

//         // Back button
//         if (e.target.closest('.cstm-back-btn')) {
//             e.preventDefault();
//             const previousLevel = history[history.length - 1];
//             if (previousLevel) {
//                 goToLevel(previousLevel.dataset.title || 'Menu', null, true);
//             } else {
//                 closeAll();
//             }
//             return;
//         }

//         // Arrow / item with children
//         const arrow = e.target.closest('.cstm-arrow');
//         const link = e.target.closest('.cstm-menu-link');

//         if (arrow || (link && link.parentElement.dataset.hasChildren === 'true')) {
//             e.preventDefault();
//             const item = link ? link.parentElement : arrow.closest('.cstm-menu-item');
//             const title = item.querySelector('.cstm-item-title')?.textContent.trim() || 'Submenu';

//             // Try to find stored children HTML (for level 3+)
//             let childrenHTML = item.dataset.childrenContainer;
//             let container;

//             if (childrenHTML) {
//                 const temp = document.createElement('div');
//                 temp.innerHTML = childrenHTML;
//                 container = temp;
//             } else {
//                 // Level 1 → level 2 uses original structure
//                 const childData = item.querySelector('.cstm-level2-data');
//                 container = childData;
//             }

//             if (container) {
//                 goToLevel(title, container);
//             }
//             return;
//         }

//         // Normal link → let browser handle it (no preventDefault)
//     });

//     // ───────────────────────────────────────────────
//     //  Hamburger
//     // ───────────────────────────────────────────────
//     if (hamburger) {
//         hamburger.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (mobileHeader.classList.contains('active')) {
//                 closeAll();
//             } else {
//                 mobileHeader.classList.add('active');
//                 menuDrawer.classList.add('cstm-open');
//                 menuOverlay.classList.add('cstm-active');
//                 document.body.style.overflow = 'hidden';
//             }
//         });
//     }

//     // Overlay → close
//     menuOverlay?.addEventListener('click', closeAll);

//     // Close on outside click (optional – you already have something similar)
//     document.addEventListener('click', e => {
//         if (!menuDrawer?.contains(e.target) && !hamburger?.contains(e.target)) {
//             if (mobileHeader?.classList.contains('active')) {
//                 closeAll();
//             }
//         }
//     });

// });



//  ya puranay wlaa ha




  

//         document.addEventListener('DOMContentLoaded', function () {

//     // ───────────────────────────────────────────────
//     //  Elements
//     // ───────────────────────────────────────────────
//     const hamburger       = document.querySelector('.cstm-hamburger');
//     const mobileHeader    = document.querySelector('.cstm-mobile-header');
//     const menuDrawer      = document.querySelector('.cstm-menu-drawer');
//     const menuOverlay     = document.querySelector('.cstm-menu-overlay');
//     const levelsContainer = document.querySelector('.cstm-menu-levels');
//     const level1          = document.querySelector('.cstm-menu-level[data-level="1"]');

//     let history = [];           // keeps track of navigation stack

//     // ───────────────────────────────────────────────
//     //  Close everything
//     // ───────────────────────────────────────────────
//     function closeAll() {
//         mobileHeader?.classList.remove('active');
//         menuDrawer?.classList.remove('cstm-open');
//         menuOverlay?.classList.remove('cstm-active');
//         document.body.style.overflow = '';

//         // Reset levels
//         document.querySelectorAll('.cstm-menu-level').forEach(el => {
//             el.classList.remove('cstm-active', 'cstm-prev');
//         });
//         if (level1) level1.classList.add('cstm-active');

//         history = [];
//     }

//    // ───────────────────────────────────────────────
// // Go to next level / previous level
// // ───────────────────────────────────────────────
// function goToLevel(title, childrenContainer, isBack = false) {
//     if (isBack) {
//         // BACK NAVIGATION
//         const current = document.querySelector('.cstm-menu-level.cstm-active');
//         if (!current) return;

//         // Previous level se wapas aana
//         current.classList.remove('cstm-active');
//         current.classList.add('cstm-next'); // optional – helps with animation direction

//         // Pehla level ya last history item ko active karo
//         let targetLevel;
//         if (history.length > 0) {
//             targetLevel = history[history.length - 1];
//             history.pop(); // remove current from history
//         } else {
//             targetLevel = level1;
//         }

//         if (targetLevel) {
//             targetLevel.classList.remove('cstm-prev', 'cstm-next');
//             targetLevel.classList.add('cstm-active');
//         }

//         return;
//     }

//     // FORWARD NAVIGATION (sub-menu kholna)
//     if (!childrenContainer) return;

//     const current = document.querySelector('.cstm-menu-level.cstm-active');
//     if (!current) return;

//     // Create or get target level
//     let newLevel = document.querySelector(`.cstm-menu-level[data-title="${CSS.escape(title)}"]`);

//     if (!newLevel) {
//         newLevel = document.createElement('div');
//         newLevel.className = 'cstm-menu-level';
//         newLevel.dataset.title = title;

//         newLevel.innerHTML = `
//             <div class="custom-back-header">
//                 <button class="cstm-back-btn">
//                     <svg viewBox="0 0 292 492"><path d="M282.666 226.796L63.338 7.86402C58.274 2.79202 51.322 0.00800542 44.114 5.73162e-06C36.902 6.04687e-06 30.046 2.79202 24.986 7.86402L8.75798 23.98C3.68998 29.052 0.897983 35.8 0.897983 43.012C0.897983 50.22 3.68998 56.976 8.75798 62.048L192.606 245.888L8.554 429.94C3.486 435.004 0.697996 441.76 0.697996 448.968C0.697996 456.176 3.486 462.936 8.554 468.004L24.682 484.124C35.17 494.62 52.254 494.62 62.742 484.124L282.666 264.988C287.73 259.924 291.298 253.176 291.298 245.904L291.298 245.82C291.298 238.608 287.726 231.86 282.666 226.796Z" fill="black"></path></svg>
//                 </button>
//                 <div class="cstm-menu-title">${title}</div>
//                 <div style="width:40px"></div>
//             </div>
//             <ul class="cstm-menu-list"></ul>
//         `;

//         const list = newLevel.querySelector('.cstm-menu-list');

//         // Copy items (same as before)
//         childrenContainer.querySelectorAll('.cstm-child, .cstm-grand').forEach(item => {
//             const li = document.createElement('li');
//             li.className = 'cstm-menu-item';
//             li.dataset.hasChildren = item.dataset.hasChildren || 'false';

//             const a = document.createElement('a');
//             a.href = item.dataset.url || '#';
//             a.className = 'cstm-menu-link';

//             // Image
//             if (item.dataset.image && item.dataset.image !== 'null' && item.dataset.image !== '') {
//                 const img = document.createElement('img');
//                 img.src = item.dataset.image;
//                 img.className = 'cstm-item-image';
//                 a.appendChild(img);
//             }

//             // Text
//             const textDiv = document.createElement('div');
//             textDiv.className = 'cstm-item-text';
//             const innerDiv = document.createElement('div');
//             const titleDiv = document.createElement('div');
//             titleDiv.className = 'cstm-item-title';
//             titleDiv.textContent = item.dataset.title;
//             innerDiv.appendChild(titleDiv);

//             if (item.dataset.description && item.dataset.description !== '') {
//                 const desc = document.createElement('div');
//                 desc.className = 'cstm-item-description';
//                 desc.textContent = item.dataset.description;
//                 innerDiv.appendChild(desc);
//             }
//             textDiv.appendChild(innerDiv);

//             if (item.dataset.tag && item.dataset.tag !== '') {
//                 const tagSpan = document.createElement('span');
//                 tagSpan.className = 'cstm-item-tag';
//                 tagSpan.textContent = item.dataset.tag;
//                 textDiv.appendChild(tagSpan);
//             }

//             a.appendChild(textDiv);

//             // Arrow
//             if (item.dataset.hasChildren === 'true') {
//                 const arrow = document.createElement('span');
//                 arrow.className = 'cstm-arrow';
//                 arrow.innerHTML = `<svg viewBox="0 0 292 492"><path d="M282.666 226.796L63.338 7.86402...Z" fill="black"/></svg>`;
//                 a.appendChild(arrow);
//             }

//             li.appendChild(a);

//             // Store next level data
//             if (item.dataset.hasChildren === 'true') {
//                 const nextData = item.querySelector('.cstm-level3-data') || item.nextElementSibling;
//                 if (nextData) {
//                     li.dataset.childrenContainer = nextData.outerHTML;
//                 }
//             }

//             list.appendChild(li);
//         });

//         levelsContainer.appendChild(newLevel);
//     }

//     // Animation – forward
//     current.classList.remove('cstm-active');
//     current.classList.add('cstm-prev');
//     newLevel.classList.remove('cstm-prev', 'cstm-next');
//     newLevel.classList.add('cstm-active');

//     // Push current level to history
//     history.push(current);
// }

//     // ───────────────────────────────────────────────
//     //  Event delegation – click on items / arrows / back
//     // ───────────────────────────────────────────────
//     menuDrawer.addEventListener('click', function (e) {

//         // Back button
//         if (e.target.closest('.cstm-back-btn')) {
//             e.preventDefault();
//             const previousLevel = history[history.length - 1];
//             if (previousLevel) {
//                 goToLevel(previousLevel.dataset.title || 'Menu', null, true);
//             } else {
//                 closeAll();
//             }
//             return;
//         }

//         // Arrow / item with children
//         const arrow = e.target.closest('.cstm-arrow');
//         const link = e.target.closest('.cstm-menu-link');

//         if (arrow || (link && link.parentElement.dataset.hasChildren === 'true')) {
//             e.preventDefault();
//             const item = link ? link.parentElement : arrow.closest('.cstm-menu-item');
//             const title = item.querySelector('.cstm-item-title')?.textContent.trim() || 'Submenu';

//             // Try to find stored children HTML (for level 3+)
//             let childrenHTML = item.dataset.childrenContainer;
//             let container;

//             if (childrenHTML) {
//                 const temp = document.createElement('div');
//                 temp.innerHTML = childrenHTML;
//                 container = temp;
//             } else {
//                 // Level 1 → level 2 uses original structure
//                 const childData = item.querySelector('.cstm-level2-data');
//                 container = childData;
//             }

//             if (container) {
//                 goToLevel(title, container);
//             }
//             return;
//         }

//         // Normal link → let browser handle it (no preventDefault)
//     });

//     // ───────────────────────────────────────────────
//     //  Hamburger
//     // ───────────────────────────────────────────────
//     if (hamburger) {
//         hamburger.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (mobileHeader.classList.contains('active')) {
//                 closeAll();
//             } else {
//                 mobileHeader.classList.add('active');
//                 menuDrawer.classList.add('cstm-open');
//                 menuOverlay.classList.add('cstm-active');
//                 document.body.style.overflow = 'hidden';
//             }
//         });
//     }

//     // Overlay → close
//     menuOverlay?.addEventListener('click', closeAll);

//     // Close on outside click (optional – you already have something similar)
//     document.addEventListener('click', e => {
//         if (!menuDrawer?.contains(e.target) && !hamburger?.contains(e.target)) {
//             if (mobileHeader?.classList.contains('active')) {
//                 closeAll();
//             }
//         }
//     });

// });








document.addEventListener('DOMContentLoaded', function () {

    // ───────────────────────────────────────────────
    //  Elements
    // ───────────────────────────────────────────────
    const hamburger       = document.querySelector('.cstm-hamburger');
    const mobileHeader    = document.querySelector('.cstm-mobile-header');
    const menuDrawer      = document.querySelector('.cstm-menu-drawer');
    const menuOverlay     = document.querySelector('.cstm-menu-overlay');
    const levelsContainer = document.querySelector('.cstm-menu-levels');
    const level1          = document.querySelector('.cstm-menu-level[data-level="1"]');

    let history = [];           // keeps track of navigation stack

    // ───────────────────────────────────────────────
    //  Close everything
    // ───────────────────────────────────────────────
    function closeAll() {
        mobileHeader?.classList.remove('active');
        menuDrawer?.classList.remove('cstm-open');
        menuOverlay?.classList.remove('cstm-active');
        document.body.style.overflow = '';

        // Reset levels
        document.querySelectorAll('.cstm-menu-level').forEach(el => {
            el.classList.remove('cstm-active', 'cstm-prev');
        });
        if (level1) level1.classList.add('cstm-active');

        history = [];
    }

   // ───────────────────────────────────────────────
   // Go to next level / previous level
   // ───────────────────────────────────────────────
   function goToLevel(title, childrenContainer, isBack = false) {
    if (isBack) {
        // BACK NAVIGATION
        const current = document.querySelector('.cstm-menu-level.cstm-active');
        if (!current) return;

        // Previous level se wapas aana
        current.classList.remove('cstm-active');
        current.classList.add('cstm-next'); // optional – helps with animation direction

        // Pehla level ya last history item ko active karo
        let targetLevel;
        if (history.length > 0) {
            targetLevel = history[history.length - 1];
            history.pop(); // remove current from history
        } else {
            targetLevel = level1;
        }

        if (targetLevel) {
            targetLevel.classList.remove('cstm-prev', 'cstm-next');
            targetLevel.classList.add('cstm-active');
        }

        return;
    }

    // FORWARD NAVIGATION (sub-menu kholna)
    if (!childrenContainer) return;

    const current = document.querySelector('.cstm-menu-level.cstm-active');
    if (!current) return;

    // Create or get target level
    let newLevel = document.querySelector(`.cstm-menu-level[data-title="${CSS.escape(title)}"]`);

    if (!newLevel) {
        newLevel = document.createElement('div');
        newLevel.className = 'cstm-menu-level';
        newLevel.dataset.title = title;

        newLevel.innerHTML = `
            <div class="custom-back-header">
                <button class="cstm-back-btn">
                    <svg viewBox="0 0 292 492"><path d="M282.666 226.796L63.338 7.86402C58.274 2.79202 51.322 0.00800542 44.114 5.73162e-06C36.902 6.04687e-06 30.046 2.79202 24.986 7.86402L8.75798 23.98C3.68998 29.052 0.897983 35.8 0.897983 43.012C0.897983 50.22 3.68998 56.976 8.75798 62.048L192.606 245.888L8.554 429.94C3.486 435.004 0.697996 441.76 0.697996 448.968C0.697996 456.176 3.486 462.936 8.554 468.004L24.682 484.124C35.17 494.62 52.254 494.62 62.742 484.124L282.666 264.988C287.73 259.924 291.298 253.176 291.298 245.904L291.298 245.82C291.298 238.608 287.726 231.86 282.666 226.796Z" fill="black"></path></svg>
                </button>
                <div class="cstm-menu-title">${title}</div>
                <div style="width:40px"></div>
            </div>
            <ul class="cstm-menu-list"></ul>
        `;

        const list = newLevel.querySelector('.cstm-menu-list');

        // Copy items (same as before)
        childrenContainer.querySelectorAll('.cstm-child, .cstm-grand').forEach(item => {
            const li = document.createElement('li');
            li.className = 'cstm-menu-item';
            li.dataset.hasChildren = item.dataset.hasChildren || 'false';

            const a = document.createElement('a');
            a.href = item.dataset.url || '#';
            a.className = 'cstm-menu-link';

            // Image wrapper
            if (item.dataset.image && item.dataset.image !== 'null' && item.dataset.image !== '') {
                const imageWrapper = document.createElement('div');  // New wrapper div
                imageWrapper.className = 'cstm-image-wrapper';      // Add class for styling
                
                const img = document.createElement('img');
                img.src = item.dataset.image;
                img.className = 'cstm-item-image';
                
                imageWrapper.appendChild(img);  // Add img to wrapper
                a.appendChild(imageWrapper);    // Add wrapper to anchor
            }

            // Text
            const textDiv = document.createElement('div');
            textDiv.className = 'cstm-item-text';
            const innerDiv = document.createElement('div');
            const titleDiv = document.createElement('div');
            titleDiv.className = 'cstm-item-title';
            titleDiv.textContent = item.dataset.title;
            innerDiv.appendChild(titleDiv);

            if (item.dataset.description && item.dataset.description !== '') {
                const desc = document.createElement('div');
                desc.className = 'cstm-item-description';
                desc.textContent = item.dataset.description;
                innerDiv.appendChild(desc);
            }
            textDiv.appendChild(innerDiv);

            if (item.dataset.tag && item.dataset.tag !== '') {
                const tagSpan = document.createElement('span');
                tagSpan.className = 'cstm-item-tag';
                tagSpan.textContent = item.dataset.tag;
                textDiv.appendChild(tagSpan);
            }

            a.appendChild(textDiv);

            // Arrow
            if (item.dataset.hasChildren === 'true') {
                const arrow = document.createElement('span');
                arrow.className = 'cstm-arrow';
                arrow.innerHTML = `<svg viewBox="0 0 292 492"><path d="M282.666 226.796L63.338 7.86402...Z" fill="black"/></svg>`;
                a.appendChild(arrow);
            }

            li.appendChild(a);

            // Store next level data
            if (item.dataset.hasChildren === 'true') {
                const nextData = item.querySelector('.cstm-level3-data') || item.nextElementSibling;
                if (nextData) {
                    li.dataset.childrenContainer = nextData.outerHTML;
                }
            }

            list.appendChild(li);
        });

        levelsContainer.appendChild(newLevel);
    }

    // Animation – forward
    current.classList.remove('cstm-active');
    current.classList.add('cstm-prev');
    newLevel.classList.remove('cstm-prev', 'cstm-next');
    newLevel.classList.add('cstm-active');

    // Push current level to history
    history.push(current);
}

    // ───────────────────────────────────────────────
    //  Event delegation – click on items / arrows / back
    // ───────────────────────────────────────────────
    menuDrawer.addEventListener('click', function (e) {

        // Back button
        if (e.target.closest('.cstm-back-btn')) {
            e.preventDefault();
            const previousLevel = history[history.length - 1];
            if (previousLevel) {
                goToLevel(previousLevel.dataset.title || 'Menu', null, true);
            } else {
                closeAll();
            }
            return;
        }

        // Arrow / item with children
        const arrow = e.target.closest('.cstm-arrow');
        const link = e.target.closest('.cstm-menu-link');

        if (arrow || (link && link.parentElement.dataset.hasChildren === 'true')) {
            e.preventDefault();
            const item = link ? link.parentElement : arrow.closest('.cstm-menu-item');
            const title = item.querySelector('.cstm-item-title')?.textContent.trim() || 'Submenu';

            // Try to find stored children HTML (for level 3+)
            let childrenHTML = item.dataset.childrenContainer;
            let container;

            if (childrenHTML) {
                const temp = document.createElement('div');
                temp.innerHTML = childrenHTML;
                container = temp;
            } else {
                // Level 1 → level 2 uses original structure
                const childData = item.querySelector('.cstm-level2-data');
                container = childData;
            }

            if (container) {
                goToLevel(title, container);
            }
            return;
        }

        // Normal link → let browser handle it (no preventDefault)
    });

    // ───────────────────────────────────────────────
    //  Hamburger
    // ───────────────────────────────────────────────
    if (hamburger) {
        hamburger.addEventListener('click', function (e) {
            e.stopPropagation();
            if (mobileHeader.classList.contains('active')) {
                closeAll();
            } else {
                mobileHeader.classList.add('active');
                menuDrawer.classList.add('cstm-open');
                menuOverlay.classList.add('cstm-active');
                document.body.style.overflow = 'hidden';
            }
        });
    }

    // Overlay → close
    menuOverlay?.addEventListener('click', closeAll);

    // Close on outside click (optional – you already have something similar)
    document.addEventListener('click', e => {
        if (!menuDrawer?.contains(e.target) && !hamburger?.contains(e.target)) {
            if (mobileHeader?.classList.contains('active')) {
                closeAll();
            }
        }
    });

});

// document.addEventListener('DOMContentLoaded', function () {
//   // Cart click proxy
//   const mobileCart = document.querySelector('.cstm-mobile-header .header__icon--cart');
//   const mainCart = document.querySelector('.header__icon.header__icon--cart');

//   if (mobileCart && mainCart) {
//     mobileCart.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       mainCart.click();
//     });
//   }

//   // Notification click proxy
//   const mobileNotify = document.querySelector('.cstm-mobile-header .header__icon.notify');
//   const mainNotify = document.querySelector('.header__icon.notify');

//   if (mobileNotify && mainNotify) {
//     mobileNotify.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       mainNotify.click();
//     });
//   }
// });


// document.addEventListener('DOMContentLoaded', function () {
//     const hamburger = document.querySelector('.cstm-hamburger');
//     const mobileHeader = document.querySelector('.cstm-mobile-header');
//     const menuDrawer = document.querySelector('.cstm-menu-drawer');
//     const menuOverlay = document.querySelector('.cstm-menu-overlay');
//     const cartIcon = document.getElementById('cart-icon-bubble');
//     const searchModal = document.querySelector('details-modal .header__search details');
//     const accountIcon = document.querySelector('.header__icon--account');
//     const notifyIcon = document.querySelector('.header__icon.notify');

//     // सभी interactive icons/elements का collection
//     const allInteractiveElements = [
//         { element: hamburger, activeClass: 'active', target: mobileHeader, additionalAction: null },
//         { element: cartIcon, activeClass: 'active', target: null, additionalAction: null },
//         { element: searchModal, activeClass: 'open', target: searchModal, additionalAction: null },
//         { element: accountIcon, activeClass: 'active', target: null, additionalAction: null },
//         { element: notifyIcon, activeClass: 'active', target: null, additionalAction: null }
//     ];

//     // किसी एक element को activate करने के लिए function
//     function activateElement(clickedElement) {
//         // पहले सभी elements से active classes हटाएं
//         deactivateAllElements();

//         // जिस element पर click किया है, उसे activate करें
//         const foundElement = allInteractiveElements.find(item => {
//             return item.element === clickedElement || 
//                    (clickedElement.closest && clickedElement.closest(item.element.selector || ''));
//         });

//         if (foundElement) {
//             if (foundElement.target) {
//                 foundElement.target.classList.add(foundElement.activeClass);
//             }
//             if (foundElement.element === hamburger) {
//                 // Hamburger के लिए विशेष handling
//                 menuDrawer.classList.add('cstm-open');
//                 menuOverlay.classList.add('cstm-active');
//                 document.body.style.overflow = 'hidden';
//             }
//             if (foundElement.additionalAction) {
//                 foundElement.additionalAction();
//             }
//         }
//     }

//     // सभी elements को deactivate करने के लिए function
//     function deactivateAllElements() {
//         // Hamburger/menu को close करें
//         if (mobileHeader) mobileHeader.classList.remove('active');
//         if (menuDrawer) menuDrawer.classList.remove('cstm-open');
//         if (menuOverlay) menuOverlay.classList.remove('cstm-active');
        
//         // Search modal को close करें
//         if (searchModal && searchModal.hasAttribute('open')) {
//             searchModal.removeAttribute('open');
//         }
        
//         // अन्य icons से active class हटाएं
//         [cartIcon, accountIcon, notifyIcon].forEach(icon => {
//             if (icon) icon.classList.remove('active');
//         });
        
//         // Body overflow reset करें
//         document.body.style.overflow = '';
//     }

//     // Hamburger के लिए event listener
//     if (hamburger) {
//         hamburger.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (mobileHeader.classList.contains('active')) {
//                 // अगर पहले से active है तो deactivate करें
//                 deactivateAllElements();
//             } else {
//                 // नहीं तो activate करें
//                 activateElement(hamburger);
//             }
//         });
//     }

//     // Cart icon के लिए event listener
//     if (cartIcon) {
//         cartIcon.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (this.classList.contains('active')) {
//                 this.classList.remove('active');
//             } else {
//                 activateElement(this);
//             }
//         });
//     }

//     // Search modal के लिए event listener
//     if (searchModal) {
//         const searchSummary = searchModal.querySelector('summary');
//         if (searchSummary) {
//             searchSummary.addEventListener('click', function (e) {
//                 e.stopPropagation();
//                 if (searchModal.hasAttribute('open')) {
//                     searchModal.removeAttribute('open');
//                     searchModal.classList.remove('open');
//                 } else {
//                     activateElement(searchModal);
//                     searchModal.setAttribute('open', '');
//                 }
//             });
//         }
//     }

//     // Account icon के लिए event listener
//     if (accountIcon) {
//         accountIcon.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (this.classList.contains('active')) {
//                 this.classList.remove('active');
//             } else {
//                 activateElement(this);
//             }
//         });
//     }

//     // Notify icon के लिए event listener
//     if (notifyIcon) {
//         notifyIcon.addEventListener('click', function (e) {
//             e.stopPropagation();
//             if (this.classList.contains('active')) {
//                 this.classList.remove('active');
//             } else {
//                 activateElement(this);
//             }
//         });
//     }

//     // Overlay पर click करने पर सब कुछ close करें
//     if (menuOverlay) {
//         menuOverlay.addEventListener('click', function (e) {
//             e.stopPropagation();
//             deactivateAllElements();
//         });
//     }

//     // Document पर click करने पर check करें कि क्या click किसी active element के बाहर हुआ है
//     document.addEventListener('click', function (e) {
//         const isClickInsideMenu = menuDrawer && menuDrawer.contains(e.target);
//         const isClickOnHamburger = hamburger && hamburger.contains(e.target);
//         const isClickOnCart = cartIcon && cartIcon.contains(e.target);
//         const isClickOnSearch = searchModal && searchModal.contains(e.target);
//         const isClickOnAccount = accountIcon && accountIcon.contains(e.target);
//         const isClickOnNotify = notifyIcon && notifyIcon.contains(e.target);
        
//         // अगर click किसी भी interactive element के अंदर नहीं हुआ है
//         if (!isClickOnHamburger && !isClickOnCart && !isClickOnSearch && 
//             !isClickOnAccount && !isClickOnNotify && !isClickInsideMenu) {
//             deactivateAllElements();
//         }
//     });

//     // Body overflow का management
//     const updateBodyOverflow = () => {
//         if (mobileHeader && mobileHeader.classList.contains('active')) {
//             document.body.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//         }
//     };

//     // Initial state (page load)
//     updateBodyOverflow();

//     // Observe class changes
//     if (mobileHeader) {
//         const observer = new MutationObserver(updateBodyOverflow);
//         observer.observe(mobileHeader, {
//             attributes: true,
//             attributeFilter: ['class']
//         });
//     }
// });










document.addEventListener('DOMContentLoaded', function () {

  // CART PROXY (unchanged)
  const mobileCart = document.querySelector('.cstm-mobile-header .header__icon--cart');
  const mainCart = document.querySelector('.header__icon.header__icon--cart');

  if (mobileCart && mainCart) {
    mobileCart.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      mainCart.click();
    });
  }

  // NOTIFICATION LOGIC
  const mobileNotify = document.querySelector('.cstm-mobile-header .header__icon.notify');
  const mainNotify   = document.querySelector('.header__icon.notify');
  const closeNotify  = document.querySelector('#close-notification');

  if (mobileNotify && mainNotify) {
    mobileNotify.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // toggle body class
      document.body.classList.toggle('active');

      // trigger main notify click ONLY when opening
      if (document.body.classList.contains('active')) {
        mainNotify.click();
      }
    });
  }

  // CLOSE BUTTON
  if (closeNotify) {
    closeNotify.addEventListener('click', function () {
      document.body.classList.remove('active');
    });
  }

});



